import getLocalString from "constants/Localization";
import { useAddMaterialNoPlantToProposalProductMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useAddMaterialNoPlantToProposalProduct() {
  const [mutation, { loading, error, data }] = useAddMaterialNoPlantToProposalProductMutation({
    refetchQueries: ["customGetProposal"],
  });

  const [addMaterialNoPlantToProposalProduct, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "addMaterialNoPlantToProposalProduct",
    },
    {
      successMessage: getLocalString("proposals.add-material-no-plant-to-proposal-product-success"),
      failureMessage: getLocalString("proposals.add-material-no-plant-to-proposal-product-failure"),
    }
  );

  return [addMaterialNoPlantToProposalProduct, context] as const;
}
